import {createSelectorCreator, defaultMemoize} from 'reselect'
import {createCachedSelector} from 're-reselect'
import _ from 'lodash'
import utils from '@eitje/utils'
import {buildRecords} from '../record_building/build_records'
import {getModel} from '../record_building/model_metadata'
import {buildJoinDependencyKeys} from '../record_building/join_plans'
import {normalizeJoinKeys, normalizeKind} from '../record_building/record_keys'

const allowedOpts = ['joins']

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual)

const normalizeOpts = opts => {
	if (!_.isObject(opts)) return {joins: []}
	if (!utils.intersects(Object.keys(opts), allowedOpts)) return {joins: []}
	return {...opts, joins: normalizeJoinKeys(opts.joins)}
}

const selectRecordSlices = (state, kind, opts = {}) => {
	kind = normalizeKind(kind)
	opts = normalizeOpts(opts)
	const {defaultJoins} = getModel(kind)
	const dependencyJoins = defaultJoins.length ? [...opts.joins, ...defaultJoins] : opts.joins
	const recordKinds = utils.exists(dependencyJoins) ? [kind, ...buildJoinDependencyKeys(dependencyJoins)] : [kind]

	return _.pick(state.records, recordKinds)
}

export const all = createCachedSelector(
	selectRecordSlices,
	(state, key) => normalizeKind(key),
	(state, key, opts) => normalizeOpts(opts),
	(ents, key, opts) => buildRecords(ents, key, opts),
)({
	keySelector: (state, key, opts = {}) => `${normalizeKind(key)}-${JSON.stringify(normalizeOpts(opts))}`,
	selectorCreator: createDeepEqualSelector,
})

export const allExternal = (state, key, query, opts) => (utils.exists(opts) ? all(state, key, opts) : all(state, key))
